import React from 'react';
import { motion } from 'framer-motion';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  return <section className="w-full bg-gradient-to-b from-[#14505c] to-[#1a3a4a] text-white min-h-screen flex items-center py-10 md:py-16" data-id="element-62">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center w-full" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-64">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-5 leading-tight" data-id="element-65">
            ORDENÁ EL PROCESO TERAPÉUTICO CON ADULTOS MAYORES DESDE LA PRIMERA
            CONSULTA
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="cursor-pointer flex justify-center mb-5" onClick={onCTAClick} data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/bgHZfHoqxefXUVScpGFVYg/Diseno_sin_titulo_(33).png" alt="KIT Psicología en Gerontes - Sistema práctico para conducir el proceso terapéutico con gerontes" className="w-full max-w-[200px] sm:max-w-[280px] md:max-w-[340px] h-auto hover:scale-105 transition-transform duration-300" data-id="element-67" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} data-id="element-68">
          <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#f0c79a] mb-4" data-id="element-69">
            KIT PSICOLOGÍA EN GERONTES™
          </p>
          <p className="text-base sm:text-lg text-white/80 mb-6 max-w-2xl mx-auto" data-id="element-70">
            Sistema práctico para conducir el proceso terapéutico con gerontes
            desde el primer día.
          </p>
          <button onClick={onCTAClick} className="bg-[#d97706] hover:bg-[#b45309] text-white font-bold text-base sm:text-lg px-8 py-4 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl w-full sm:w-auto" data-id="element-71">
            SÍ, QUIERO EL KIT AHORA
          </button>
          <p className="text-sm text-white/70 mt-4" data-id="element-72">
            Acceso inmediato · Pago único y seguro
          </p>
        </motion.div>
      </div>
    </section>;
}